import { Modal } from 'react-bootstrap';
import logoImage from "../../assest/images/cancleicon.png"
const CancelConfirmation = ({
    showModal,
    setShowModal,
    onClickYes,
    cancellationPolicy
}) => {
    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            backdrop="none"
            centered
            className='verification-modal confirmation-modal dark_common_modal'
        >
            <Modal.Body>
                <div className="container">
                    <a href="javascript:void(0)"><img src={logoImage} alt="logo-img" /></a>
                    <h4>Are you sure you want to <br /> cancel the order?</h4>
                    <h6>Are you sure you want to cancel the order? This action cannot be undone, and you may lose any reserved items or special offers.</h6>
                    {cancellationPolicy != "" && <h6 className='redColorText'>NOTE : {cancellationPolicy}</h6>}

                </div>
                < div className="continueBox">
                    <button className="btn continueBtn" onClick={() => setShowModal(false)} style={{ marginTop: "0" }}>No </button>
                    <button className="btn continueBtn" onClick={() => onClickYes()} style={{ marginTop: "0" }}>Yes </button>
                </div>

            </Modal.Body>
        </Modal >
    )
}
export default CancelConfirmation